import { FormEvent, useCallback, useEffect } from 'react';
import Button from 'src/components/Button';
import { useCheckbox } from 'src/components/Checkbox';
import { useFormInputEmail, useFormInputPassword } from 'src/components/FormInput';
import { useTranslation } from 'react-i18next';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { getAutoLogin, setAutoLogin } from 'src/services/storage';
import Icon from 'src/components/Icon';

export default function LoginView({
  onSubmit,
  isShowAutoLogin,
}: {
  onSubmit: (e: FormEvent) => void;
  isShowAutoLogin: boolean;
}): JSX.Element {
  const { t } = useTranslation();
  const history = useCustomHistory();
  const emailInput = useFormInputEmail();
  const passwordInput = useFormInputPassword();
  const autoLoginCheckbox = useCheckbox({
    name: 'auto',
    component: <label className="N_12_R text-brown-grey">{t('login/autologin_title')}</label>,
  });

  const goRouter = useCallback(
    (e, url) => {
      e.preventDefault();
      history.push(url, {
        beforeLoginEndpoint: '/login',
      });
    },
    [history],
  );

  const onFormSubmit = useCallback(
    (e) => {
      e.preventDefault();
      isShowAutoLogin && setAutoLogin(autoLoginCheckbox.checked);
      onSubmit(e);
    },
    [autoLoginCheckbox.checked],
  );

  useEffect(() => {
    if (!isShowAutoLogin) return;
    const autoLogin = getAutoLogin();
    autoLoginCheckbox.setChecked(autoLogin);
  }, []);

  return (
    <div className="container">
      <form onSubmit={onFormSubmit} className="flex flex-col items-center justify-center">
        <div className="mt-8 text-lg leading-normal">
          <Icon name="logo" size="130" sizeH="120" />
        </div>
        <div className="w-full mt-7">{emailInput.CustomFormInput}</div>
        <div className="w-full mt-5">{passwordInput.CustomFormInput}</div>
        {isShowAutoLogin && <div className="w-full mt-5 flex justify-end">{autoLoginCheckbox.CustomCheckbox}</div>}
        <div className="w-full mt-7">
          <Button title={t('login/login_button')} type="submit" disabled={!(emailInput.isValid && passwordInput.isValid)}></Button>
        </div>
        <div className="mt-5 mb-10 flex justify-center items-center text-xs text-greyish-brown">
          <a href="#" onClick={(e) => goRouter(e, '/password/reset')}>
            {t('login/find_password_button')}
          </a>
          <span className="division mx-4"></span>
          <a href="#" onClick={(e) => goRouter(e, '/account/age')}>
            {t('login/join_button')}
          </a>
        </div>
      </form>
    </div>
  );
}
